module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Column-names",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "Column-names"
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-4"
    }
  }), _vm._v("Dream Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "Column-dates"
  }, [_c('span', {
    staticClass: "Column-dates _idGenCharOverride-5"
  }, [_vm._v("February 8, 2013")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Some people wait their entire lives to find their dream home. I’ve already lived in several.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("At our first assignment in Texas, my husband and I lived in our first real house. It was my dream home because it had a fireplace. We didn’t have much furniture to put in it. And we used a rotary push mower, a gift from my grandfather, until we could afford a gas-powered lawn mower to cut the grass. It had a big backyard, a rectangle of concrete for a patio, and even a grapevine.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Our first on-base home, at Sheppard Air Force Base, Texas, was my dream home because it had hardwood floors and big windows. We brought our first baby home there.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Our second baby came home to a dream house on a tropical island, complete with a hibiscus bush and a hammock between two palm trees. Our house on Andersen Air Force Base, Guam, wasn’t much to look at. With concrete walls, flat roof, and brown plywood shutters, it was more like a bunker, but it survived five typhoons and an earthquake, and it was less than ten minutes from the beach.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Our house on Luke Air Force Base, Arizona, was the house of my dreams mostly because it was ")]), _c('span', {
    staticClass: "Text CharOverride-11"
  }, [_vm._v("available")]), _c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v(". After spending five months on the housing list in a sparsely furnished apartment with two small children, I could easily love the outdated cabinets, tiny closets, and oddly-paneled ceiling. By the time we left that dream house, with baby number three, we were bursting at its three-bedroom seams.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("So naturally, our next dream house in Japan was even smaller. It had a closet under the stairs and, although we could have used the storage space, it got better use as a secret hideout, playhouse, or pirate cave on rainy days. Outside our windows, we had cherry blossoms in the spring and fiery red maple leaves in the fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Our dream home in Valdosta, Georgia, was a family favorite. It had a fireplace, a second story, plenty of space inside, and nearby woods and ponds outside. Dad and the kids built a tree house and picked blackberries for Mom to bake homemade cobblers. Quiet streets and lots of open spaces provided our children room for adventure and scope for the imagination.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("At Los Angeles Air Force Base, California, our dream home had a view of the ocean and Catalina Island on a clear day from one of the upstairs windows, if you stood in just the right spot. The daily walk to the elementary school was a flower-lined sidewalk with a full view of the Pacific. With beautiful weather almost every day, we enjoyed our back patio and pergola. No fireplace, no air conditioning, but we rarely needed either one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Our dream home at Ramstein, Germany, had three floors, a spiral staircase, balcony, and did I mention, was in Germany? Dream location and the last of our dream homes to house all our children year-round, it was walking distance down cobblestone streets to favorite restaurants, bakeries, and coffee shops.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("Of all of these dream homes, our home in Virginia has the most space, which we most enjoy when it’s full of our family and friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("I don’t know how many more dream homes we’ll have. Someday we hope to have one that is truly ours and will be ours for a long time. When choosing it, I don’t know that I’ll be looking for the “must haves” the HGTV hosts rave about, such as granite countertops, recessed lighting, or a rain shower.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("My “must haves” are a kitchen in which to cook for family and friends. A dining room big enough to hold them all. A sidewalk that leads into town. A sofa by the fireplace would be nice, and plenty of shelves for the books we like to read. Wall space for pictures from all over. Bedrooms for the beds our children used to jump on and dream on. Maybe their children will jump and dream on them, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Para"
  }, [_c('span', {
    staticClass: "Text _idGenCharOverride-5"
  }, [_vm._v("When it’s time to look for that dream home, I’ll be looking for glimpses of the dreams from every home we’ve ever lived in.")])]), _vm._v(" "), _c('p', {
    staticClass: "Stars-End-Column"
  }, [_c('span', {
    staticClass: "Stars-End-Column _idGenCharOverride-6"
  }, [_vm._v("*** ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e631d47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spousecalls5.vue
// module id = 72
// module chunks = 0